/**
 * NOWROCKY™ — live buyers + licznik sztuk
 * Port systemu z poprzedniego sklepu (React/zustand) na czysty JS pod motyw Shopify.
 *
 * Zasady portu:
 *  - zero zaleznosci: brak Reacta, zustand i framer-motion,
 *  - avatary: DiceBear (6 malutkich SVG w naglowku) + lokalna sylwetka jako fallback.
 *    UWAGA DLA NASTEPNEJ SESJI: ten naglowek dlugo klamal, ze avatary sa lokalne,
 *    i to podtrzymalo blad. Awatary NIE renderowaly sie nie dlatego, ze DiceBear jest
 *    zly, tylko dlatego, ze mialy loading="lazy" ustawione przed wstawieniem do DOM.
 *    Nie przywracaj 'lazy' w klastrze.
 *  - nie modyfikujemy plikow motywu: skrypt sam znajduje header i przycisk koszyka,
 *  - konfiguracja przychodzi z sekcji przez window.NOWROCKY_LIVE_CONFIG.
 *
 * Wyciete wzgledem oryginalu: zegar "cancer-counter", StrajkAvatarCluster,
 * copy o zbiorce i "join the gang", prefiksy lg_* oraz telemetria do obcego API.
 */
(function () {
  'use strict';

  var CFG = Object.assign({
    enabled: true,
    headerCluster: true,
    ctaCluster: true,
    toast: true,
    stockCounter: true,
    minDelay: 9000,
    maxDelay: 24000,
    toastMs: 5000,
    clusterSize: 6,
    clusterSizeMobile: 3,
    accent: '#DC143C',
    maxStock: 12,
    lowStock: 3,
    sound: false,
  }, window.NOWROCKY_LIVE_CONFIG || {});

  if (!CFG.enabled) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    CFG.toast = false; // ruch ograniczony przez uzytkownika — zostawiamy same avatary
  }

  var NS = 'nowrocky:live:v1';
  var STOCK_KEY = NS + ':stock';

  /* ---------------- deterministyczny PRNG (zamiast zegara z poprzedniego sklepu) -------- */
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rngFrom(seed) {
    var a = seed >>> 0;
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  var pick = function (arr, r) { return arr[Math.floor((r || Math.random()) * arr.length)]; };

  /* ---------------- avatary: DiceBear (ludzie), jak w dzialajacej wersji sklepu -------
     PRZYWROCONE. Wyciecie DiceBeara bylo bledna decyzja: mierzone bajty pokazaly,
     ze strona glowna wazyla 2631 KB, z czego 2593 KB to WIDEO hero. Awatary to 6
     malutkich SVG — w bajtach praktycznie zero. Zamienniki generowane lokalnie
     (sylwetka, potem twarz) nie czytaly sie przy 24 px i wlasciciel zglaszal to
     wielokrotnie. Wydajnosc naprawiamy na wideo, nie na awatarach. */
  /* ---------------- awatary: JEDEN sprite zamiast requestu na twarz ----------------
     Grafiki sa te same co wczesniej (DiceBear), tylko sklejone w `nwr-awatary.svg`
     przez `work/gen-awatary-sprite.py`. Zamiast adresu zwracamy NUMER KAFELKA —
     CSS przesuwa tlo na wlasciwa twarz. Dzieki temu klaster kosztuje jeden
     request na cala sesje, a rotacja co 9-24 s juz nic nie pobiera.

     Losowanie zostaje deterministyczne wzgledem seeda, wiec ten sam kupujacy ma
     miedzy odswiezeniami te sama twarz — tak jak dzialalo do tej pory. */
  var SPRITE = CFG.sprite || '';
  var AV_ILE = CFG.spriteCount || 16;
  function indeksAwatara(seed) {
    var r = rngFrom(hash(String(seed)));
    return Math.floor(r() * AV_ILE);
  }






  /* Kafelek sprite'a jako element. <span> zamiast <img>, bo klaster ma rozne
     rozmiary (22 px w naglowku, 26 px na mobile, 20 px przy koszyku), a tylko
     `background-position` w procentach skaluje sie razem z pudelkiem. */
  function twarz(idx) {
    var el = document.createElement('span');
    el.className = 'nwr-live-face';
    el.style.setProperty('--nwr-av', String(idx || 0));
    return el;
  }

  /* ---------------- i18n: teksty ida z sekcji (Liquid), PL jako fallback -----------
     Bez tego widget wstrzykiwal polskie zdania rowniez na /en i /zh. Robi to w JS
     w czasie rzeczywistym, wiec Translate & Adapt nigdy tych stringow nie widzial. */
  var I18N = window.NOWROCKY_LIVE_I18N || {};

  var NAMES = I18N.names || ['Kuba', 'Michał', 'Bartek', 'Kamil', 'Piotr', 'Marek', 'Adam', 'Tomek', 'Paweł', 'Wojtek', 'Damian', 'Rafał', 'Sebastian', 'Krzysiek', 'Mateusz', 'Dawid', 'Łukasz', 'Grzesiek', 'Zuza', 'Ola', 'Kasia', 'Magda', 'Ania', 'Natalia', 'Karolina', 'Paulina', 'Wiktoria', 'Julia', 'Marta', 'Ewa', 'Gosia', 'Klaudia', 'Dominika', 'Patrycja'];

  var CITIES = I18N.cities || ['z Warszawy', 'z Krakowa', 'z Łodzi', 'z Wrocławia', 'z Poznania', 'ze Szczecina', 'z Gdańska', 'z Bydgoszczy', 'z Lublina', 'z Katowic', 'z Białegostoku', 'z Gdyni', 'z Częstochowy', 'z Radomia', 'z Torunia', 'z Kielc', 'z Rzeszowa', 'z Gliwic', 'z Zabrza', 'z Olsztyna', 'z Bielska-Białej', 'z Sosnowca', 'z Tychów', 'z Legnicy', 'z Płocka', 'z Opola', 'z Elbląga', 'z Wałbrzycha', 'z Włocławka', 'z Rybnika', 'z Zielonej Góry', 'z Gorzowa Wielkopolskiego', 'z Chorzowa', 'z Koszalina', 'z Kalisza', 'z Pragi', 'z Mokotowa', 'z Woli', 'z Ursynowa', 'z Bemowa', 'z Targówka', 'z Bródna'];

  /* wzorce zdan: {n} = imie, {c} = miasto, {p} = produkt */
  var PATTERNS = I18N.templates || [
    '{n} {c} wziął {p}',
    '{n} {c} — {p} w koszyku',
    '{p} leci {c}',
    '{n} {c} domknął {p}',
    '{n} {c} bierze {p}'
  ];
  var QUOTES = I18N.quotes || ['„', '”'];

  var TEMPLATES = PATTERNS.map(function (tpl) {
    return function (n, c, p) {
      return String(tpl).replace('{n}', n).replace('{c}', c).replace('{p}', p);
    };
  });

  /* ---------------- stan + PERSYSTENCJA (avatary stale miedzy odswiezeniami) ------------ */
  var SEEDS_KEY = NS + ':seeds';
  var buyers = [];   // URL-e avatarow (pochodne seedow)
  var seeds = [];    // stabilne seedy zapisane w localStorage
  var toastEl = null;
  var toastTimer = null;

  function loadSeeds() {
    try { var s = JSON.parse(localStorage.getItem(SEEDS_KEY) || 'null'); return Array.isArray(s) && s.length ? s : null; }
    catch (e) { return null; }
  }
  function saveSeeds() { try { localStorage.setItem(SEEDS_KEY, JSON.stringify(seeds)); } catch (e) { /* brak miejsca */ } }

  function seedBuyers(n) {
    var loaded = loadSeeds();
    if (loaded) { seeds = loaded; }              // ten sam zestaw co poprzednio -> zero migotania
    else {
      seeds = [];
      for (var i = 0; i < n; i++) seeds.push('nwr-' + i + '-' + Math.floor(Math.random() * 1e9));
      saveSeeds();                                // wylosowane RAZ, potem stale
    }
    buyers = seeds.map(indeksAwatara);
  }

  /* ---------------- klaster avatarow ----------------------------------------------------- */
  function buildCluster(anchor, size) {
    var wrap = document.createElement('span');
    wrap.className = 'nwr-live-cluster';
    wrap.setAttribute('data-nwr-anchor', anchor);
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < size; i++) {
      var s = document.createElement('span');
      s.className = 'nwr-live-av';
      s.style.zIndex = String(i + 1);
      /* Historia, ktora warto znac: do v19 awatary mialy tu loading="lazy"
         ustawiane PRZED wstawieniem do dokumentu i Chrome nigdy ich nie pobieral —
         stad "kolka zamiast ludzi". Przy sprite ten problem znika z definicji,
         bo nie ma juz osobnego obrazka na twarz. */
      s.appendChild(twarz(buyers[i] != null ? buyers[i] : indeksAwatara('init-' + i)));
      wrap.appendChild(s);
    }
    return wrap;
  }

  function rotateClusters() {
    var seed = 'nwr-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
    seeds.push(seed); if (seeds.length > 12) seeds.shift();
    saveSeeds();                                  // rotacja też trwała — refresh pokaże aktualny stan
    var next = indeksAwatara(seed);
    buyers.push(next);
    if (buyers.length > 12) buyers.shift();
    document.querySelectorAll('.nwr-live-cluster').forEach(function (cl) {
      var first = cl.firstElementChild;
      if (!first) return;
      cl.removeChild(first);
      var s = document.createElement('span');
      s.className = 'nwr-live-av nwr-live-in';
      s.style.zIndex = String(cl.children.length + 1);
      s.appendChild(twarz(next));
      cl.appendChild(s);
      // ostatni avatar to kotwica dla dymka
      cl.querySelectorAll('[data-nwr-latest]').forEach(function (e) { e.removeAttribute('data-nwr-latest'); });
      s.setAttribute('data-nwr-latest', '1');
    });
  }

  /* ---------------- pula produktow: z Liquid, bez zewnetrznego API ---------------------- */
  var POOL = Array.isArray(window.NOWROCKY_LIVE_PRODUCTS) ? window.NOWROCKY_LIVE_PRODUCTS.slice() : [];

  function productLabel() {
    if (!POOL.length) return 'drop';
    var p = pick(POOL);
    return typeof p === 'string' ? p : (p.title || 'drop');
  }
  function productHref() {
    if (!POOL.length) return null;
    var p = pick(POOL);
    return typeof p === 'object' && p.url ? p.url : null;
  }

  /* ---------------- dymek ---------------------------------------------------------------- */
  function showToast() {
    if (!CFG.toast) return;
    var anchor = document.querySelector('.nwr-live-cluster[data-nwr-anchor="header"] [data-nwr-latest]')
      || document.querySelector('.nwr-live-cluster[data-nwr-anchor="header"]');
    if (!anchor) return;

    var p = POOL.length ? pick(POOL) : null;
    var label = p ? (typeof p === 'string' ? p : p.title) : 'drop';
    var href = p && typeof p === 'object' ? p.url : null;
    var text = pick(TEMPLATES)(pick(NAMES), pick(CITIES), QUOTES[0] + label + QUOTES[1]);

    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'nwr-live-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var inner = href ? document.createElement('a') : document.createElement('span');
    if (href) { inner.href = href; inner.className = 'nwr-live-toast-link'; }
    inner.textContent = text;
    toastEl.appendChild(inner);

    var r = anchor.getBoundingClientRect();
    var headerEl = document.querySelector('#header-component') || document.querySelector('header');
    var headerBottom = (headerEl && headerEl.getBoundingClientRect().height > 0) ? headerEl.getBoundingClientRect().bottom : r.bottom;
    var topPos = Math.round(Math.max(r.bottom, headerBottom) + 6);

    toastEl.style.top = topPos + 'px';
    document.documentElement.style.setProperty('--nwr-toast-top', topPos + 'px');
    toastEl.style.right = Math.max(12, window.innerWidth - r.right - 6) + 'px';
    toastEl.classList.add('is-on');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl && toastEl.classList.remove('is-on'); }, CFG.toastMs);
    if (CFG.sound) ping();
  }

  /* ---------------- dzwiek (WebAudio, bez plikow) --------------------------------------- */
  var actx = null;
  function ping() {
    try {
      actx = actx || new (window.AudioContext || window.webkitAudioContext)();
      var o = actx.createOscillator(), g = actx.createGain();
      o.type = 'sine'; o.frequency.setValueAtTime(880, actx.currentTime);
      o.frequency.exponentialRampToValueAtTime(1320, actx.currentTime + 0.08);
      g.gain.setValueAtTime(0.05, actx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.0001, actx.currentTime + 0.25);
      o.connect(g); g.connect(actx.destination); o.start(); o.stop(actx.currentTime + 0.26);
    } catch (e) { /* audio zablokowane — pomijamy */ }
  }

  /* ---------------- licznik sztuk (per wariant, sessionStorage) -------------------------- */
  function stockAll() {
    try { return JSON.parse(sessionStorage.getItem(STOCK_KEY) || '{}'); } catch (e) { return {}; }
  }
  function stockSave(o) {
    try { sessionStorage.setItem(STOCK_KEY, JSON.stringify(o)); } catch (e) { /* brak miejsca */ }
  }
  function stockFor(variantId) {
    if (!variantId) return null;
    var all = stockAll();
    if (typeof all[variantId] !== 'number') {
      all[variantId] = 1 + Math.floor(Math.random() * CFG.maxStock);
      stockSave(all);
    }
    return all[variantId];
  }
  function stockDecrement(variantId, by) {
    var all = stockAll();
    if (typeof all[variantId] !== 'number') return;
    all[variantId] = Math.max(1, all[variantId] - (by || 1)); // podloga 1: nie wygaszamy sprzedazy
    stockSave(all);
    renderStock();
  }
  function currentVariantId() {
    // motyw Horizon/Ritual: <variant-picker> zamiast <input name=id>.
    // Klucz stanu wiążemy z wariantem, jeśli jest, inaczej z produktem (pathname).
    var el = document.querySelector('form[action*="/cart/add"] [name="id"]')
      || document.querySelector('variant-picker [name="id"]')
      || document.querySelector('[name="id"]');
    if (el && el.value) return 'v:' + el.value;
    return 'p:' + location.pathname.replace(/\/+$/, '');
  }
  var lastRenderedVariant = null;
  function renderStock() {
    if (!CFG.stockCounter) return;
    var host = document.querySelector('[data-nwr-stock]');
    if (!host) return;
    /* Wariant niedostepny: motyw wygasza przycisk. "ZOSTALO 6 SZT." pod martwym
       przyciskiem to sprzecznosc — chowamy licznik (CSS ma [data-nwr-stock]:empty). */
    var atcBtn = document.querySelector('add-to-cart-component button, button[name="add"]');
    if (atcBtn && atcBtn.disabled) {
      host.textContent = ''; host.removeAttribute('data-low');
      lastRenderedVariant = currentVariantId();
      return;
    }
    lastRenderedVariant = currentVariantId();
    var q = stockFor(lastRenderedVariant);
    if (q == null) { host.textContent = ''; return; }
    var ST = I18N.stock || { last: 'OSTATNIA SZTUKA', few: 'ZOSTAŁY {q} SZTUKI', many: 'ZOSTAŁO {q} SZT.' };
    var tpl = q === 1 ? ST.last : (q <= CFG.lowStock ? ST.few : ST.many);
    host.textContent = String(tpl).replace('{q}', q);
    host.setAttribute('data-low', q <= CFG.lowStock ? '1' : '0');
  }

  /* ---------------- wstrzykniecie w motyw (bez edycji plikow) --------------------------- */
  function mount() {
    /* 750 px, ten sam prog co breakpoint motywu i co @media w nowrocky-live.css —
       inaczej miedzy 750 a 767 px liczba awatarow i ich rozmiar rozjezdzaly sie. */
    var size = window.innerWidth < 750 ? CFG.clusterSizeMobile : CFG.clusterSize;

    // --- klaster w nagłówku (motyw Horizon/Ritual: <header-actions>) ---
    if (CFG.headerCluster && !document.querySelector('.nwr-live-cluster[data-nwr-anchor="header"]')) {
      var host = document.querySelector('[data-nwr-slot="header"]')
        || document.querySelector('header-actions')
        || document.querySelector('header-component')
        || document.querySelector('.header-actions')
        || document.querySelector('header');
      if (host) {
        var c = buildCluster('header', size);
        c.style.marginRight = '10px';
        // wstaw na początku akcji, żeby avatary były widoczne obok ikon
        host.insertBefore(c, host.firstChild);
        var last = c.lastElementChild;
        if (last) last.setAttribute('data-nwr-latest', '1');
      }
    }

    // --- klaster przy przycisku koszyka (<add-to-cart-component>) ---
    if (CFG.ctaCluster && !document.querySelector('.nwr-live-cluster[data-nwr-anchor="cta"]')) {
      var atc = document.querySelector('add-to-cart-component')
        || document.querySelector('product-form-component add-to-cart-component')
        || document.querySelector('button[name="add"]');
      if (atc && atc.parentElement) {
        var wrap = document.createElement('span');
        wrap.className = 'nwr-live-cta';
        wrap.appendChild(buildCluster('cta', 4));
        atc.parentElement.insertBefore(wrap, atc.nextSibling);
      }
    }

    // --- licznik sztuk: sam tworzymy host, bo motyw go nie ma ---
    if (CFG.stockCounter && !document.querySelector('[data-nwr-stock]')) {
      var anchor = document.querySelector('add-to-cart-component')
        || document.querySelector('product-form-component');
      if (anchor && anchor.parentElement) {
        var s = document.createElement('div');
        s.setAttribute('data-nwr-stock', '');
        anchor.parentElement.insertBefore(s, anchor);
      }
    }

    renderStock();
  }

  /* ---------------- petla ---------------------------------------------------------------- */
  function tick() {
    rotateClusters();
    showToast();
    if (Math.random() < 0.45) {
      var v = currentVariantId();
      if (v) stockDecrement(v, 1 + Math.floor(Math.random() * 2));
    }
    schedule();
  }
  function schedule() {
    var d = CFG.minDelay + Math.random() * (CFG.maxDelay - CFG.minDelay);
    setTimeout(function () { if (!document.hidden) tick(); else schedule(); }, d);
  }

  function init() {
    seedBuyers(Math.max(CFG.clusterSize, 8));
    mount();
    schedule();
    // zmiana wariantu: stary form ORAZ nowy <variant-picker>
    /* SYNCHRONIZACJA Z WARIANTEM — poprawka zmierzona na zywym sklepie.
       BYLO: setTimeout(renderStock, 80). Motyw Horizon/Ritual podmienia blok produktu
       przez Section Rendering API, czyli PO SIECI. Pomiar na /products/womens-performance-
       crop-t-shirt: po zmianie Rozmiaru input [name=id] dostawal nowa wartosc dopiero
       miedzy 1000 a 1800 ms, po zmianie Koloru miedzy 200 a 600 ms. Licznik czytal stan
       po 80 ms, czyli STARY wariant, i przez ok. 1-1,8 s pokazywal cudza liczbe
       (zmierzone: "ZOSTALO 8 SZT." przy juz wybranym rozmiarze L).
       JEST: po zdarzeniu odpytujemy stan co 100 ms, dopoki ID wariantu faktycznie sie
       nie zmieni (limit 4 s). Reagujemy na fakt, nie na timer. */
    var watchTimer = null;
    function watchVariant() {
      clearInterval(watchTimer);
      var t0 = Date.now();
      watchTimer = setInterval(function () {
        if (!document.querySelector('[data-nwr-stock]')) mount();
        if (currentVariantId() !== lastRenderedVariant) renderStock();
        if (Date.now() - t0 > 4000) clearInterval(watchTimer);
      }, 100);
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest &&
          e.target.closest('form[action*="/cart/add"], variant-picker, product-form-component')) {
        watchVariant();
      }
    });

    /* Podmiana bloku produktu przez motyw nie zawsze emituje 'change' (np. wybor
       wariantu z galerii albo powrot przyciskiem wstecz). Obserwator lapie tez
       przypadek, w ktorym re-render zabiera nasz host — wtedy montujemy go z powrotem. */
    if (window.MutationObserver) {
      var moBusy = false;
      var mo = new MutationObserver(function () {
        if (moBusy) return;
        moBusy = true;
        try {
          if (!document.querySelector('[data-nwr-stock]')) mount();
          else if (currentVariantId() !== lastRenderedVariant) renderStock();
        } finally { moBusy = false; }
      });
      /* TYLKO gdy na stronie jest formularz produktu. Wczesniej fallbackiem byl
         `document.body` z `subtree:true`, wiec na stronie glownej obserwowany byl
         caly dokument, a callback przy kazdej paczce mutacji wchodzil w mount()
         i przemiatal dokument osmioma zapytaniami — zawsze bez skutku, bo na
         glownej nie ma czego montowac. Rotacja klastra sama mutuje DOM, wiec
         obserwator karmil sam siebie co 9-24 s. Licznik sztuk istnieje wylacznie
         na karcie produktu, wiec poza nia obserwator nie ma zadnego zadania. */
      var host = document.querySelector('product-form-component');
      if (host) mo.observe(host, { childList: true, subtree: true });
    }
    /* Rozmiar klastra byl liczony TYLKO raz, przy starcie. Podglad w edytorze motywu
       startuje w szerokosci desktopowej, wiec na mobile zostawalo 6 awatarow zamiast 2
       i blok akcji wchodzil na wordmark. CSS ma twardy limit (to jest gwarancja),
       a tu doprowadzamy liczbe elementow do stanu zgodnego z aktualna szerokoscia,
       zeby przy powrocie na desktop nie zostaly tylko dwa. */
    var lastSize = null;
    function syncClusterSize() {
      var chce = window.innerWidth < 750 ? CFG.clusterSizeMobile : CFG.clusterSize;
      if (chce === lastSize) return;
      lastSize = chce;
      var cl = document.querySelector('.nwr-live-cluster[data-nwr-anchor="header"]');
      if (!cl) return;
      while (cl.children.length > chce) cl.removeChild(cl.firstElementChild);
      while (cl.children.length < chce) {
        var s = document.createElement('span');
        s.className = 'nwr-live-av';
        var zapas = buyers[cl.children.length % buyers.length];
        s.appendChild(twarz(zapas != null ? zapas : indeksAwatara('fill-' + cl.children.length)));
        cl.insertBefore(s, cl.firstChild);
      }
      var last = cl.lastElementChild;
      cl.querySelectorAll('[data-nwr-latest]').forEach(function (e) { e.removeAttribute('data-nwr-latest'); });
      if (last) last.setAttribute('data-nwr-latest', '1');
    }
    syncClusterSize();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (toastEl) toastEl.classList.remove('is-on');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncClusterSize, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
